import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const { t } = i18n.global;

function buildConfigSections(): ConfigSection[] {
  return [
    { component: "ConfSection", props: { name: "branch" } },
    // World section: "Create a new world" button (header) opens a modal carrying the create-time
    // map-gen-settings; the section body holds the persistent map-settings fields.
    { component: "FactorioWorldSettings", props: { name: "worldSettings" } },
    { component: "ConfSection", props: { name: "basic" } },
    { component: "ConfSection", props: { name: "extended" } },
    { component: "ConfSection", props: { name: "admin" } },
    { component: "TableSection", props: { name: "adminList" } },
    { component: "ConfSection", props: { name: "whitelistSettings" } },
    { component: "TableSection", props: { name: "whitelist" } },
  ];
}

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  menu[0].items.push(commonMenuItems.console);
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/factorio_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections: buildConfigSections(),
  statusPageConfig: {
    showRconPort: true,
    showQueryPort: false,
    showFtp: true,
  },
  join: {
    buttonTextKey: "ngp/settings/section/factorio_wiki",
    joinFn: join,
  },
});
